/**************** Important Song Constants ********************************/
// Be careful when changing these!
// Key is the only enum here that corresponds directly to Genesis proto.
export enum Key {
  C = 0,
  C_SHARP = 1,
  D = 2,
  D_SHARP = 3,
  E = 4,
  F = 5,
  F_SHARP = 6,
  G = 7,
  G_SHARP = 8,
  A = 9,
  A_SHARP = 10,
  B = 11
}

export enum Scale {
  CHROMATIC = 0,
  MAJOR = 1,
  MINOR = 2
}

export enum BeatResolution {
  QUARTER_NOTE = 0,
  EIGHTH_NOTE = 1,
  SIXTEENTH_NOTE = 2,
  QUARTER_NOTE_TRIPLETS = 3,
  EIGHTH_NOTE_TRIPLETS = 4,
  SIXTEENTH_NOTE_TRIPLETS = 5,
  THIRTY_SECOND_NOTES = 6
}

// This is a concept that only exists in genesis, so we label it clearly.
export enum GenesisSampleType {
  HAT = 1,
  PERC = 3,
  SNARE = 4,
  KICK = 6,
  BASS = 7,
  MELODY = 8,
  HARMONY = 9,
  SPECIAL = 11,
  CLAP = 5,
  HI_HAT_ALT = 2,
  CHANT = 10
}

export const MAJOR_SCALE = [
  true,
  false,
  true,
  false,
  true,
  true,
  false,
  true,
  false,
  true,
  false,
  true
]
export const MINOR_SCALE = [
  true,
  false,
  true,
  true,
  false,
  true,
  false,
  true,
  true,
  false,
  true,
  false
]

export const MIDDLE_C = 60

/************************************************/
